import type { TaskRunSummary } from "@mlx/contracts";

/*
 * The words the run trace prints (TaskRunActivity): its pill, its count and
 * its footer. Plain functions, so a fixture run labels itself the same way.
 */

/** "14 updates": a run's trace lines, counted. */
export function formatUpdateCount(count: number): string {
  return `${count} update${count === 1 ? "" : "s"}`;
}

/** A finished run reads as the answer's working, not as an engineering trace. */
export function runActivityLabel(terminal: boolean): string {
  return terminal ? "How I answered" : "Agent activity";
}

/** The trace footer's status line for a run. */
export function runFooterStatus(status: TaskRunSummary["status"]): string {
  if (status === "failed") return "Run failed";
  if (status === "cancelled") return "Run cancelled";
  if (status === "completed") return "Run complete";
  return "Twin running";
}
